import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, PRIMARY_OUTLET } from "@angular/router";
import { Breadcrumb } from './breadcrumb.model';
import { BreadcrumbService } from './breadcrumb.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

  public breadcrumbs: Breadcrumb[];
  private subscription: Subscription = new Subscription();
  
  constructor(
    private breadcrumbService: BreadcrumbService
  ) { 
  	this.breadcrumbs = [];
  }

  ngOnInit() {
    this.subscription = this.breadcrumbService.breadcrumbChange.subscribe((breadcrumbs) => { 
       for (let breadcrumb of breadcrumbs) {
       	if (!breadcrumb.params) breadcrumb.params = {}
       }
      this.breadcrumbs = breadcrumbs;
    });
  }
 
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
